import React, { useState } from 'react';
import { StepContainer, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { ReferenciasInfo } from '../sections';

export const Step20_ReferenciaFamiliar2: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.referenceNameTwo) newErrors.referenceNameTwo = 'Nome da referência é obrigatório';
    if (!data.referencePhoneTwo) newErrors.referencePhoneTwo = 'Telefone da referência é obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ referenceNameTwo: data.referenceNameTwo, referencePhoneTwo: data.referencePhoneTwo });
  };

  const handleFieldChange = (newData: Partial<typeof data>) => {
    // Mapear dados da seção ReferenciasInfo para os campos do contexto
    if ('name' in newData) {
      updateField('referenceNameTwo', newData.name);
    }
    if ('phone' in newData) {
      updateField('referencePhoneTwo', newData.phone);
    }
    
    Object.keys(newData).forEach(key => {
      if (errors[key]) {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[key];
          return newErrors;
        });
      }
    });
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">Referência 2 - preencha nome e grau de parentesco</p>
        
       

        <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">
          <p className="text-amber-900 text-sm">
            <span className="font-semibold">Por exemplo: João - pai</span>
          </p>
        </div>
      </div>

      <ReferenciasInfo
        numero={2}
        data={{
          name: data.referenceNameTwo || '',
          phone: data.referencePhoneTwo || '',
        }}
        onChange={handleFieldChange}
      />

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20_ReferenciaFamiliar2;
